import { isMobile } from 'react-device-detect';

/* eslint-disable no-unused-vars */
export const AppDefaults = {
  COMPANY_NAME: 'CleanDesk AI Pvt. Ltd.',
  APP_NAME: 'CleanDesk AI',
  APP_DESCRIPTION:
    'Citizens Relationship Management & Helpdesk Platform for Legislators',

  APP_VERSION: '1.4.38',
  APP_BUILD: '618',

  AUTH_HOME: isMobile ? '/dashboard/support' : '/home-in', // /community/all

  APP_FALLBACK_URL: 'https://mylegislator.page.link/app-link',

  APP_ANDROID_URL:
    'https://play.google.com/store/apps/details?id=com.resurge.clean.clean_legislator',
  APP_IOS_URL: 'https://apps.apple.com/in/app/clean-legislator/id1660927705',
};

export enum StatusCodes {
  SUCCESS_CODE = 'S10001',
  FAILURE_CODE = 'F90001',
}

export enum ResolutionTypes {
  SIXFOUR = 64,
  ONETWOEIGHT = 128,
  TWOFIVESIX = 256,
  FIVEONETWO = 512,
}

export enum ServiceTypes {
  PERSON = 'person',
  LEGISLATOR = 'legislator',
  ORGANISATION = 'organisation',
  CUSTOMER = 'customer',
  CITIZEN = 'citizen',
  GOVERNMENT = 'government',
  BUSINESS = 'business',
  COMPANY = 'company',
  POST = 'post',
  ROOM = 'room',
  CLASS = 'class',
  SUBJECT = 'subject',
  LANGUAGE = 'language',
  SKILL = 'skill',
  EVENT = 'event',
  CANCEL_REASONS_SELLER_INITIATED = 'CANCELREASONSELLERINITIATED',
  CANCEL_REASONS_BUYER_INITIATED = 'CANCELREASONSBUYERINITIATED',
  RETURN_REPLACEMENT_REASONS = 'RETURNREPLACEMENTREASONS',
}

export enum ROOM_PRIVACY_TYPE {
  ALL = 'all',
  PRIVATE = 'private',
  PUBLIC = 'public',
  SOCIAL = 'social',
  COWORKERS = 'coworkers',
  PARTNER = 'partner',
}

export enum ContextTypes {
  PROFILE = 'profile',
  HELPDESK = 'helpdesk',
}

export enum PostTypes {
  TICKET = 'ticket',
  GENERAL = 'general',
  NOTICE = 'notice',
  BLOG = 'blog',
  QNA = 'qa',
  POLL = 'poll',
  NEWS = 'news',
  BOOKMARK = 'bookmark',
  LESSON = 'lesson',
  ASSIGNMENT = 'assignment',
  FAQ = 'faq',
  POLICY = 'policy',
  HELPDOC = 'helpdoc',
  CAMPAIGN = 'campaign',
  SALES_REPORT = 'sales_report',
  SEEN = 'seen',
  WELCOME_POST = 'welcome_post',
}

export enum PostStatus {
  READ = 'read',
  UNREAD = 'unread',
  HIDDEN = 'hidden',
}

export enum UserActions {
  IS_FOLLOWED = 'is_followed',
}

export enum DictionaryTypes {
  LEGISLATOR_CATEGORIES = 'LEGCAT',
  BUSINESS_TYPES = 'BUSTYPE',
  BUSINESS_CATEGORIES = 'BUSCAT',
  ORGANISATION_INDUSTRY = 'ORGINDUSTRY',

  INDUSTRY_TYPES = 'ORGINDUSTRYTYPE',
  INDUSTRY_DOMAINS = 'INDUSTRYDOMAIN',

  DEACTIVATION_REASONS = 'DEACTIVATEUSER',

  AI_DOC_TARGET_AUDIENCE = 'AIDOCTARGETAUDIENCE',
  AI_DOC_CONTENT_TYPE = 'AIDOCCONTENTTYPE',

  BRANCHTYPE = 'BRANCHTYPE',
  BUSINESS_UNIT_TYPES = 'BUSINESSUNITTYPE',
  BUSINESS_UNIT_TYPES_NEW = 'BUSINESSUNITTYPENEW',

  REASON_FOR_DEACTIVATION = 'REASONFORDEACTIVATION',
  REASON_FOR_ACTIVATION = 'REASONFORREACTIVATION',
}

export enum HELPDESK {
  STATUS = 'status',
  CALLBACK = 'callback',
  LEAD = 'lead',
  PRIORITY = 'priority',
  CATEGORY = 'category',
  SKILL = 'skill',
  TIER = 'tier',

  UNASSIGNED = 'Unassigned',
  ASSIGNED = 'Assigned',
  ONHOLD = 'On Hold',
  RESOLVED = 'Resolved',
  REOPEN = 'Reopen',
  CLOSED = 'Closed',

  BOT_REQ_OFFICE = 'office',
  BOT_REQ_CATEGORY = 'category',
  BOT_REQ_MEDIA = 'media',
  BOT_REQ_LOCATION = 'location',
}

export enum UserRoles {
  admin = 'ADMIN',
}

export enum PeopleTypes {
  TEAM = 'Team',
  CITIZEN = 'Citizens',
}

export enum AppTypes {
  LEGISLATOR = 'LEGISLATOR',
  EMPLOYEE = 'ORGANISATION',
  ORGANISATION = 'ORGANISATION',
  CUSTOMER = 'CITIZEN',
  CITIZEN = 'CITIZEN',
  GOVERNMENT = 'GOVERNMENT',
  BUSINESS = 'BUSINESS',
}

export enum AgentTypes {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export const userNotVerifiedText =
  'This action is inaccessible until account is verified.';

export enum AuthTypes {
  LOGIN = 'LOGIN',
  REGISTRATION = 'USERREGISTRATION',
}

export const disallowedDomains = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'protonmail.com',
  'icloud.com',
  'gmx.com',
  'zoho.com',
  'mail.com',
  'yandex.com',
  'inbox.com',
  'fastmail.com',
  'tutanota.com',
  'mail.ru',
  'rediffmail.com',
  'gmx.de',
  'gmx.us',
  'gmx.net',
  'gmx.at',
  'gmx.ch',
  'gmx.fr',
  'gmx.co.uk',
  'gmx.es',
  'gmx.it',
  'gmx.nl',
  'gmx.se',
  'gmx.com.br',
  'gmx.com.mx',
  'gmx.com.ar',
  'gmx.ca',
  'gmx.co.in',
  'gmx.com.au',
  'gmx.ie',
  'gmx.pt',
  'gmx.pl',
  'gmx.co.nz',
  'gmx.com.tr',
  'gmx.cz',
  'gmx.dk',
  'gmx.no',
  'gmx.fi',
  'gmx.be',
  'gmx.hr',
  'gmx.hu',
  'gmx.sk',
  'gmx.si',
  'gmx.ro',
  'gmx.bg',
  'gmx.gr',
  'gmx.ru',
  'gmx.bg',
];

export enum MESSAGE_KEY {
  SOCKET_NOT_CONNECTED = 'Socket Not Connected',
  DELETE = 'DELETE',
  REPLY = 'REPLY',
  FORWARD = 'FORWARD',
  COPY = 'COPY',
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  FILE = 'file',
}

export enum HELPDESK_COLORS {
  UNASSIGNED = '#F8F9FA',
  ASSIGNED = '#E2E3E5',
  ONHOLD = '#FFF3CD',
  RESOLVED = '#D1ECF1',
  REOPEN = '#F8D7DA',
  CLOSED = '#D4EDDA',
}

export enum PRODUCTS_ENUM {
  all = 'ALL',
  category = 'CATEGORY',
  brand = 'BRAND',
  catalog = 'CATALOG',
  product = 'PRODUCT',
}

export enum RECIPIENTS_TYPE {
  customemployee = 'customemployee',
  custompartner = 'custompartner',
  myself = 'myself',
  business = 'business',
  myteam = 'myteam',
  partner = 'partner',
  customer = 'customer',
  mypartner = 'mypartner',
  myteampartner = 'myteampartner',
  community = 'community',
  partnerbusiness = 'partnerbusiness',
  person = 'person',
}

export enum ORDER_TYPE {
  STANDARD = 'Standard',
  EXPRESS = 'Express',
  BACKORDER = 'Backorder',
  PREORDER = 'Preorder',
}

export enum APPROVAL_STATUS {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
}

export enum ORDER_STATUS {
  PENDING = 'Pending',
  PROCESSING = 'Processing',
  SHIPPED = 'Shipped',
  DELIVERED = 'Delivered',
  CANCELLED = 'Canceled',
  RETURNED = 'Returned',
  COMPLETED = 'Completed',
}

export enum ORDER_SOURCE {
  WEB = 'Web',
  MOBILE = 'Mobile',
  PHONE = 'Phone',
  EMAIL = 'Email',
  IN_STORE = 'In-Store',
}

export enum ORDER_PRIORITY {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  URGENT = 'Urgent',
}

export enum ORDER_PAYMENT_STATUS {
  PENDING = 'Pending',
  PARTIAL = 'Partial',
  PAID = 'Paid',
  REFUNDED = 'Refunded',
  FAILED = 'Failed',
}

export enum RETURN_STATUS {
  NONE = 'None',
  REQUESTED = 'Requested',
  PROCESSING = 'Processing',
  RETURNED = 'Returned',
  REJECTED = 'Rejected',
}

export enum UserTypes {
  EMPLOYEE = 'Employee',
  CUSTOMER = 'Customer',
  PARTNER = 'Partner',
}

export enum PartnerTypes {
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
  TERTIARY = 'Tertiary',
}

export const LoyaltyTierReviewOutcomes = {
  PASSED: 'passed',
  FAILED: 'failed',
  NOT_APPLICABLE: 'na',
};

export const LoyaltyTierTransitionTypes = {
  UPGRADE: 'upgrade',
  DOWNGRADE: 'downgrade',
};

export const CONVERSATION_META_TYPES = {
  QR_CODE: 'qr_code',
};

export const CONVERSATION_META_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
};

export const CONVERSATION_META_QR_ERROR_CODES = {
  CODE_IN_USE: 'E108',
  CODE_INVALID: 'E106',
};
